import React from 'react';
import { Link } from '@inertiajs/react';
import ThemeWrapper from '@/components/ThemeWrapper';

interface AccessDeniedProps {
    reason?: string;
    required_permission?: string;
    user_groups: string[];
    is_authenticated: boolean;
}

export default function AccessDenied({
    reason = "No tienes permiso para acceder a este recurso",
    required_permission: _required_permission,
    user_groups: _user_groups = [],
    is_authenticated = false,
}: AccessDeniedProps) {
    return (
        <ThemeWrapper>
            <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full space-y-8">
                    <div className="text-center">
                        <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-red-100 mb-6">
                            <svg
                                className="h-12 w-12 text-red-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                />
                            </svg>
                        </div>

                        <h1 className="text-4xl font-bold text-gray-900 mb-2">
                            Acceso Denegado
                        </h1>

                        <p className="text-xl text-gray-600 mb-8">{reason}</p>

                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                            <Link
                                href="/"
                                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-lg font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                            >
                                Ir al Inicio
                            </Link>
                            <Link
                                href="/my-account"
                                className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-lg font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors"
                            >
                                Mi Cuenta
                            </Link>
                        </div>

                        {!is_authenticated && (
                            <p className="text-base text-gray-600 mt-6">
                                Por favor{' '}
                                <Link href="/auth/login/" className="text-blue-600 hover:text-blue-700 font-medium">
                                    inicia sesión
                                </Link>{' '}
                                para acceder a este recurso.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </ThemeWrapper>
    );
}
